import React from 'react';
import { ArrowLeft, Trash2, Mail } from 'lucide-react';
import Seo from './components/Seo';

const DeleteData = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-sans py-12">
      <Seo
        title="Delete Your Data — Jobisa"
        description="Request deletion of your Jobisa account and all associated data including Video CVs. Contact us at hiring@jobisa.in."
        path="/delete-data"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Jobisa — Delete Your Data',
          url: 'https://jobisa.in/delete-data',
          description: 'Request deletion of your Jobisa account and all associated data.',
        }}
      />
      <div className="container mx-auto px-6 lg:px-12 max-w-3xl bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
        <a href="/" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-8 font-medium">
          <ArrowLeft size={20} className="mr-2" /> Back to Home
        </a>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center">
            <Trash2 size={24} className="text-red-500" />
          </div>
          <div>
            <h1 className="text-3xl font-bold font-display text-jobisa-navy">Delete Your Data</h1>
            <p className="text-gray-500 text-sm mt-1">Account & Data Deletion Request</p>
          </div>
        </div>

        <div className="space-y-6 leading-relaxed text-gray-700">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
            <p className="font-semibold text-amber-900 mb-2">What gets deleted?</p>
            <ul className="list-disc pl-5 space-y-1 text-amber-800 text-sm">
              <li>Your Jobisa account and login credentials</li>
              <li>All personal profile information (name, phone, city, skills)</li>
              <li>Video CVs and voice recordings</li>
              <li>Uploaded documents (photos, certificates, IDs)</li>
              <li>Chat messages and application history</li>
              <li>WhatsApp onboarding data (if applicable)</li>
            </ul>
          </div>

          <div className="border border-gray-200 rounded-xl p-6 space-y-5">
            <h2 className="text-xl font-bold text-jobisa-navy">How to Request Deletion</h2>

            <div className="flex items-start gap-4 bg-blue-50 border border-blue-100 rounded-lg p-4">
              <Mail size={20} className="text-blue-600 mt-0.5 shrink-0" />
              <div>
                <p className="font-semibold text-blue-900">Email</p>
                <p className="text-sm text-blue-800 mt-1">
                  Send an email to{' '}
                  <a href="mailto:hiring@jobisa.in" className="font-bold underline">
                    hiring@jobisa.in
                  </a>{' '}
                  from your registered email address with the subject line <strong>"DELETE MY DATA"</strong>.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
              <p>
                <strong>Processing Time:</strong> We will process and confirm your data deletion within{' '}
                <strong>48 hours</strong> of receiving your request. You will receive a confirmation once the deletion is
                complete.
              </p>
            </div>
          </div>

          <div className="text-sm text-gray-500 border-t border-gray-100 pt-5">
            <p>
              For any questions about data handling, please refer to our{' '}
              <a href="/privacy-policy" className="text-blue-600 font-medium hover:underline">
                Privacy Policy
              </a>{' '}
              or contact us at{' '}
              <a href="mailto:hiring@jobisa.in" className="text-blue-600 font-medium hover:underline">
                hiring@jobisa.in
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteData;
